module.exports = __webpack_public_path__ + "img/blueline.7d798734.svg";